// extracted by mini-css-extract-plugin
export default {"CreateClass":"CreateClass_CreateClass__rwdt2","header":"CreateClass_header__zUlZQ"};